module.exports = __webpack_public_path__ + "img/imgs.d79bdba7.png";